import {createApp} from 'vue';
import Vue from 'vue';

import App from './App.vue';
import ChangeAvatar from './СhangeAvatar';

import './styles/main.scss'

document.addEventListener("DOMContentLoaded", function (event) {
    let changeAvatar = document.querySelector('#changeAvatar');
    if (changeAvatar) {
        let avatar = createApp(ChangeAvatar);
        avatar.mount('#changeAvatar');
    }

    let reviews = document.querySelector('#reviews');
    if (reviews) {
        let app = createApp(App);
        app.mount('#reviews');
    }
})